import React, { useContext } from "react";
import { SubscriptionDetailContext } from "../../../context/SubscriptionDetailContext";
import * as styles from "./styles.module.scss";
import { messages } from "../messages";
import { Title } from "@yoast/ui-library";
import { FormattedMessage } from "react-intl";
import { ExternalLink } from "../../ExternalLink";
import PropTypes from "prop-types";

/**
 * A list of included services in the subscription
 * @returns {Element} The included services.
 * @param {object} props The component props.
 */
export const IncludedServices = ( { withInstallGuide = false } ) => {
	const { subscription, request: { isFirstLoad } } = useContext( SubscriptionDetailContext );

	if ( isFirstLoad || subscription.included.inSelf.invitableServices.length === 0 ) {
		return <></>;
	}

	return <section className={ styles.includedServices }>
		<Title as={ "p" } size={ "5" }>
			<FormattedMessage { ...messages.productsTitle } />
		</Title>
		<ul className={ styles.serviceList }>
			{ subscription.included.inSelf.invitableServices.map( service => {
				const actionMessage = service.link?.action.toLowerCase() === "install" ? messages.installLinkText : {};
				return <li key={ service.name }>
					<div>
						<span>{ service.name }</span>
						{ service.link &&
							<ExternalLink
								href={ service.link.url }
								size="small"
								className={ styles.link }
							>
								<FormattedMessage { ...actionMessage } />
							</ExternalLink>
						}
					</div>
				</li>;
			} ) }
		</ul>
		{ withInstallGuide && <p>
			<ExternalLink href={ "https://yoa.st/yoast-seo-google-docs-installation-guide-checkout" }>
				<FormattedMessage { ...messages.installationGuide } />
			</ExternalLink>
		</p> }
	</section>;
};

IncludedServices.propTypes = {
	withInstallGuide: PropTypes.bool,
};
